import React from "react";
import {graphql, useStaticQuery} from "gatsby";

const AboutPageSchema = ({ title, image, datePublished, dateModified, author, description }) => {

    const { acfTheme } = useStaticQuery(graphql`
        query QueryAcfThemeArticle {
          acfTheme: wp {
            acfThemeGeneralSettings {
              aCFoptionTemplate {
                micromarkup { 
                  name
                  logo {
                    node {
                      localFile {
                        publicURL
                      }
                    }
                  }
                }  
              } 
            }
          }  
        }
    `);

    const { micromarkup } = acfTheme.acfThemeGeneralSettings.aCFoptionTemplate;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://molfarpublishing.ua/"
        },
        "headline": title || "Про нас",
        "description": "Видавництво Molfar ✓ Про нас ✓ Найкраща фантастика та манґа українською",
        "publisher": {
            "@type": "Organization",
            "name": "Видавництво Molfar",
            "logo": {
                "@type": "ImageObject",
                "url": image || "https://molfarpublishing.ua/blog-article.jpg"
            }
        },
        "image": {
            "@type": "ImageObject",
            "url": "https://molfarpublishing.ua" + micromarkup?.logo?.node?.localFile?.publicURL || "https://molfarpublishing.ua/molfar-logo.jpg"
        },
        "datePublished": "2013-08-10",
        "author": {
            "@type": "Person",
            "name": "Антон Гаюр",
            "jobTitle": "Директор видавництва",
            "image": {
                "@type": "ImageObject",
                "url": "https://molfarpublishing.ua/anton-haiur.jpg"
            }
        }
    };

    return (
        <script
            className="AboutPage"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};

export default AboutPageSchema;
